// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// Element额外提供的一系列类名，用于在某些条件下隐藏元素。这些类名可以添加在任何 DOM 元素或自定义组件上
import 'element-ui/lib/theme-chalk/display.css';

/* 路由 */
import router from './router'
import '../src/assets/aLI/iconfont.css'

/* swiper */
// import 'swiper/dist/css/swiper.min.css';
// import 'swiper/swiper.min.css';
import 'swiper/swiper-bundle.min.css';


/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
// import './assets/css/bootstrap.min.css'
// import './assets/js/bootstrap.min'

import './assets/css/index.scss'
/* 通用公共样式 */
import './assets/css/common.scss'

/* animate.css */
import 'animate.css'
import store from './store'
import i18n from './lang'
import Langs from './components/Lang'

/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)
Vue.component('LangS', Langs)
Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
});

Vue.use(ElementUI, {
  size: 'mini' // set element-ui default size

})


new Vue({
  store,
  i18n,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js